import httpRequest from "@/services/httpRequest"

export default ({
    namespaced: true,
    state: {
        savingSaldo: 0,
        savingDetails: [],
        isLoading: true,
    },
    mutations: {
        SET_SAVING_SALDO(state, data) {
            if (data) {
                state.savingSaldo = data.total_savings || 0
            } else {
                state.savingSaldo = 0
            }
        },
        
        SET_SAVING_DETAIL(state, data) {
            state.savingDetails = data
            state.isLoading = false
        }
    },
    actions: {
        async getSavingSaldo({rootState, commit}) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/studentsavingssummary`,
                    method: 'GET',
                },
                authorized: true
            }

            const res = await httpRequest(payload)

            if (res.status === 200) {
                commit('SET_SAVING_SALDO', res.data.results[0])
            } else {
                //console.log('getPaymentHistory res = ', res)
            }
        },
        
        async getSavingDetail({rootState, commit}) {
            const payload = {
                options: {
                    url: `${rootState.baseURL}/api/v1/studentsavings`,
                    method: 'GET',
                },
                authorized: true
            }
            
            const res = await httpRequest(payload)
            
            if (res.status === 200) {
                //console.log('response = ', res.data.results)
                commit('SET_SAVING_DETAIL', res.data.results)
            } else {
                //console.log('getPaymentHistory res = ', res)
            }
        }
    }
})